import { Button, ButtonProps } from '@healthinal/ui';

interface Props extends Omit<ButtonProps, 'variant' | 'color'> {
  variant?: ButtonProps['variant'];
  color?: ButtonProps['color'];
}

export function DashedButton({ variant = 'outlined', color = 'neutral', ...props }: Props) {
  return (
    <Button
      {...props}
      variant={variant}
      color={color}
      sx={{ borderStyle: 'dashed', borderWidth: '2px', height: '100%', ...props.sx }}>
      {props.children}
    </Button>
  );
}
